import type { Component, Entity2D } from '../../odie';

import { BubblesBlockProps } from '../defs/block';
import { BubblesBlockView } from '../views/blocks/BubblesBlockView';

// types
//-----------------------------------------------------------------------------
export type BubblesBlockComponentOptions = {
  props: BubblesBlockProps;
  amount?: number;
};

/*
    bubbles block component
*/
export class BubblesBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockBubbles';

  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: BubblesBlockView;

  // impl
  //-------------------------------------------------------------------------
  public init(options: BubblesBlockComponentOptions): void {
    this.view = new BubblesBlockView({ ...options.props });
  }
}
